const namespace = 'GroupsUsers';

export const REQUEST_GROUP_USERS = `${namespace}/REQUEST_GROUPS_USERS`;
export const RECEIVE_GROUP_USERS_SUCCESS = `${namespace}/RECEIVE_GROUPS_USERS_SUCCESS`;
export const RECEIVE_GROUP_USERS_FAILURE = `${namespace}/RECEIVE_GROUPS_USERS_FAILURE`;

export const REQUEST_USER_GROUPS_SAVE = `${namespace}/REQUEST_USER_GROUPS_SAVE`;
export const RECEIVE_USER_GROUPS_SUCCESS = `${namespace}/RECEIVE_USER_GROUPS_SUCCESS`;
export const RECEIVE_USER_GROUPS_FAILURE = `${namespace}/RECEIVE_USER_GROUPS_FAILURE`;
